import { IMAGE_URLS } from 'src/assets/urlLinks'

export const TESTIMONIALS = [
  {
    id: 1,
    quote:
      'Klayder feels like the future of merch. Fast, smooth, and incredibly well thought out. Service still feels personal, and the catalog never feels overwhelming. || Klayder känns som merchvärldens framtid. Snabbt, smidigt och otroligt genomtänkt. Service känns fortfarande personlig, och sortimentet blir aldrig överväldigande.',
    name: 'Alexander Ashman',
    title:
      'Marketing manager, Asurgent || Marknadschef, Asurgent',
    image: IMAGE_URLS.images.asurgent,
  },
] as const
